import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import { toast } from 'sonner';
import { Check, Trash2, Star } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${API}/testimonials?approved_only=false`, { withCredentials: true });
      setTestimonials(data.sort((a, b) => new Date(b.date) - new Date(a.date)));
    } catch (error) {
      toast.error('Erreur');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.put(`${API}/testimonials/${id}/approve`, {}, { withCredentials: true });
      toast.success('Avis approuvé');
      fetchTestimonials();
    } catch (error) {
      toast.error('Erreur');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cet avis ?')) return;
    try {
      await axios.delete(`${API}/testimonials/${id}`, { withCredentials: true });
      toast.success('Avis supprimé');
      fetchTestimonials();
    } catch (error) {
      toast.error('Erreur');
    }
  };

  return (
    <AdminLayout title="Gestion des Avis Clients">
      {loading ? (
        <div>Chargement...</div>
      ) : (
        <div className="grid gap-4">
          {testimonials.map((test) => (
            <div key={test.id} className="bg-white p-4 rounded-lg border" data-testid={`testimonial-item-${test.id}`}>
              <div className="flex justify-between items-start mb-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-lg font-medium text-[#5C2018]">{test.name}</h3>
                    {!test.approved && (
                      <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded text-xs">
                        En attente
                      </span>
                    )}
                  </div>
                  <div className="flex gap-1 mb-2">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={16}
                        className={i < test.rating ? 'fill-[#B8922A] text-[#B8922A]' : 'text-[#332724]/20'}
                      />
                    ))}
                  </div>
                  <p className="text-sm text-[#332724]">{test.comment}</p>
                  <p className="text-xs text-[#332724]/70 mt-2">
                    {new Date(test.date).toLocaleDateString('fr-FR')}
                  </p>
                </div>
                <div className="flex gap-2 ml-4">
                  {!test.approved && (
                    <button
                      onClick={() => handleApprove(test.id)}
                      className="p-2 text-green-600 hover:bg-green-50 rounded"
                      data-testid={`approve-${test.id}`}
                    >
                      <Check size={18} />
                    </button>
                  )}
                  <button
                    onClick={() => handleDelete(test.id)}
                    className="p-2 text-red-600 hover:bg-red-50 rounded"
                    data-testid={`delete-${test.id}`}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminTestimonials;
